<template>
  <div>
    <v-list-group
      v-if="item.children"
      :value="item.active"
      class="custom-list-group"
    >
      <template v-slot:activator>
        <v-list-item @click="activate" :to="item.route">
          <v-list-item-icon>
            <v-icon class="mx-n3" color="white">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content class="mx-n4">
            <v-list-item-title class="white--text"
              ><span>{{ $t(item.title) }}</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template v-slot:append-icon>
        <v-icon class="custom-icon" color="red">mdi-chevron-right</v-icon>
      </template>
      <v-list-item
        v-for="(childItem, childIndex) in item.children"
        :key="childIndex"
        :to="childItem.route"
        :class="{ active: childItem.active }"
        @click="activateChildItem(childItem)"
      >
        <v-list-item-icon>
          <v-icon color="white">{{ childItem.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="white--text"
            ><span>{{ $t(childItem.title) }}</span></v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
    </v-list-group>
    <v-list-item
      class="d-flex"
      v-else
      :to="item.route"
      :class="{ active: item.active }"
      @click="activate"
      @mouseover="hover = true"
      @mouseleave="hover = false"
    >
      <v-list-item-icon>
        <v-icon
          :mdi="item.icon"
          color="white"
          :class="{ 'icon-hover': hover }"
          >{{ item.icon }}</v-icon
        >
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title class="white--text"
          ><span>{{ $t(item.title) }}</span></v-list-item-title
        >
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      hover: false,
    };
  },
  methods: {
    activate() {
      this.$emit("activate", this.item);
      if (this.item.title == "logout") {
        this.$emit("logout");
      }
    },
    activateChildItem(childItem) {
      this.$emit("activate", childItem);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/variables";
</style>
